import { render, staticRenderFns } from "./TechExpertApproval.vue?vue&type=template&id=5235e018&scoped=true"
import script from "./TechExpertApproval.vue?vue&type=script&lang=js"
export * from "./TechExpertApproval.vue?vue&type=script&lang=js"
import style0 from "./TechExpertApproval.vue?vue&type=style&index=0&id=5235e018&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235e018",
  null
  
)

export default component.exports